var XPortal = XPortal || {};

XPortal.PageHeader = (function () {
    var self =
    {
        body: 'body',
        header: '.header-wrapper',
        pageHeader: '.edit-btns-wrapper_header',
        pageContent: '.content-detail',
        Init: function (isForDetail) {
            if (isForDetail)
                return initDetailPageHeader();

            const isDetailPage = $(self.body).hasClass('xpage-xentitydetail');
            if (isDetailPage == false)
                return initSiteHeader();
        }
    };
    function initDetailPageHeader() {
        const windowWidth = $(window).width();
        const $body = $(self.body);
        const $headerWrapper = $(self.header);
        const $pageHeader = $(self.pageHeader);
        const $pageContent = $(self.pageContent);
        const activeClass = 'page-header-sticky';
        const pageContentActiveclass = 'page-header-sticky';
        const minimazeMainHeaderClass = 'header-wrapper_min';
        const bodyHasMinimazeMainHeaderClass = 'has-header-wrapper-min';
        const headerHeightOffset = windowWidth < 767 ? 8 : 22;

        if (!$pageHeader.length > 0) return;

        const headerHeight = $headerWrapper.outerHeight() - headerHeightOffset || 0;
        const pageHeaderOffset = $pageHeader.offset().top;
        const pageHeaderHeight = $pageHeader.outerHeight() || 0;

        const desktopMedia = window.matchMedia('(min-width: 992px)');
        let lastScrollTop = 0;

        function onScroll() {
            const scrollTop = $(window).scrollTop();
            const shouldMinimize = desktopMedia.matches && scrollTop >= 1;
            // Detectiong scroll direction
            if (scrollTop > lastScrollTop) {
                $pageHeader.removeClass('scroll-top').addClass('scroll-bottom');
                $pageContent.removeClass(pageContentActiveclass).css('padding-top', 0);
            } else {
                $pageHeader.removeClass('scroll-bottom').addClass('scroll-top');
            }

            if (scrollTop >= 1) {
                $pageHeader.addClass(activeClass).css('top', 72);
                $pageContent.addClass(pageContentActiveclass).css('padding-top', 54);
            } else {
                $pageHeader.removeClass(activeClass).css('top', 0);
                $pageContent.removeClass(pageContentActiveclass).css('padding-top', 0);
            }

            $headerWrapper.toggleClass(minimazeMainHeaderClass, shouldMinimize);
            $body.toggleClass(bodyHasMinimazeMainHeaderClass, shouldMinimize);
            lastScrollTop = scrollTop;
        }

        $(window).on('scroll resize', onScroll);
        onScroll();
    };
    function initSiteHeader() {
        const $body = $(self.body);

        const $headerWrapper = $(self.header);
        const minimazeMainHeaderClass = 'header-wrapper_min';
        const bodyHasMinimazeMainHeaderClass = 'has-header-wrapper-min';
        const headerHeight = $headerWrapper.outerHeight() - 22 || 0;
        const desktopMedia = window.matchMedia('(min-width: 992px)');

        function onScroll() {
            const scrollTop = $(window).scrollTop();
            const shouldMinimize = desktopMedia.matches && scrollTop >= headerHeight + 30;

            $headerWrapper.toggleClass(minimazeMainHeaderClass, shouldMinimize);
            $body.toggleClass(bodyHasMinimazeMainHeaderClass, shouldMinimize);
        }

        $(window).on('scroll resize', onScroll);
        onScroll();

        initLinksToggle();
        initEnterToggle();

    };

    function initEnterToggle() {
        $('.enter-dropdown .btn-enter').on('click', function(e) {
            e.stopPropagation();
            $(this).closest('.enter-dropdown').toggleClass('is-shown');
        });

        $(document).on('click', function() {
            $('.enter-dropdown').removeClass('is-shown');
        });
    };

    function initLinksToggle() {
        $('.header-block.links').on('click', function(e) {
            e.stopPropagation();
            $(this).toggleClass('is-shown');
        });

        $('.tabs-header.links-content-cnt').on('click', function(e) {
            e.stopPropagation();
        });

        $(document).on('click', function() {
            $('.header-block.links').removeClass('is-shown');
        });
    };


    return self;
}());
    